import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "../CartContext";
import { SettingsContext } from "../SettingsContext";

function BottomNav() {
  const location = useLocation();
  const { cart } = useContext(CartContext);
  const { settings } = useContext(SettingsContext);

  const whatsappNumber = settings?.whatsapp || "919588051702";
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
    "Hello Daawat Achar, I want to inquire about your authentic pickles."
  )}`;

  const totalCartCount = cart.reduce((sum, item) => sum + (item.quantity || 1), 0);

  const isActive = (path) => location.pathname === path;

  // Hide bottom nav on specific checkout/payment fullscreen flows if desired
  if (location.pathname === "/checkout-success" || location.pathname === "/order-failed") {
    return null;
  }

  return (
    <div
      className="d-block d-lg-none fixed-bottom bg-white shadow-lg border-top"
      style={{
        zIndex: 1030,
        backgroundColor: "rgba(255, 255, 255, 0.98)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderColor: "#EAE2D5",
        paddingBottom: "max(6px, env(safe-area-inset-bottom, 6px))",
        paddingTop: "6px",
      }}
    >
      <div className="container px-2">
        <div className="d-flex justify-content-around align-items-center">
          {/* Home */}
          <Link
            to="/"
            className="text-decoration-none d-flex flex-column align-items-center py-1 px-2 position-relative"
            style={{
              color: isActive("/") ? "#023319" : "#6c757d",
              transition: "all 0.2s ease",
            }}
          >
            <i
              className="fa-solid fa-house"
              style={{
                fontSize: "18px",
                color: isActive("/") ? "#023319" : "#7A8288",
              }}
            ></i>
            <span
              style={{
                fontSize: "10px",
                fontWeight: isActive("/") ? "700" : "500",
                marginTop: "2px",
                letterSpacing: "0.2px",
              }}
            >
              Home
            </span>
            {isActive("/") && (
              <span
                className="position-absolute bottom-0 rounded-pill"
                style={{
                  width: "16px",
                  height: "2.5px",
                  backgroundColor: "#c49b5b",
                  marginBottom: "-4px",
                }}
              />
            )}
          </Link>

          {/* All Pickles / Products */}
          <Link
            to="/all-products"
            className="text-decoration-none d-flex flex-column align-items-center py-1 px-2 position-relative"
            style={{
              color: isActive("/all-products") ? "#023319" : "#6c757d",
              transition: "all 0.2s ease",
            }}
          >
            <i
              className="fa-solid fa-jar"
              style={{
                fontSize: "18px",
                color: isActive("/all-products") ? "#023319" : "#7A8288",
              }}
            ></i>
            <span
              style={{
                fontSize: "10px",
                fontWeight: isActive("/all-products") ? "700" : "500",
                marginTop: "2px",
                letterSpacing: "0.2px",
              }}
            >
              Pickles
            </span>
            {isActive("/all-products") && (
              <span
                className="position-absolute bottom-0 rounded-pill"
                style={{
                  width: "16px",
                  height: "2.5px",
                  backgroundColor: "#c49b5b",
                  marginBottom: "-4px",
                }}
              />
            )}
          </Link>

          {/* Cart with Live Badge */}
          <Link
            to="/cart"
            className="text-decoration-none d-flex flex-column align-items-center py-1 px-2 position-relative"
            style={{
              color: isActive("/cart") ? "#023319" : "#6c757d",
              transition: "all 0.2s ease",
            }}
          >
            <div className="position-relative">
              <i
                className="fa-solid fa-bag-shopping"
                style={{
                  fontSize: "19px",
                  color: isActive("/cart") ? "#023319" : "#7A8288",
                }}
              ></i>
              {totalCartCount > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                  style={{
                    backgroundColor: "#c49b5b",
                    color: "#ffffff",
                    fontSize: "9px",
                    padding: "2px 5px",
                    fontWeight: "700",
                    border: "1.5px solid #ffffff",
                  }}
                >
                  {totalCartCount}
                </span>
              )}
            </div>
            <span
              style={{
                fontSize: "10px",
                fontWeight: isActive("/cart") ? "700" : "500",
                marginTop: "2px",
                letterSpacing: "0.2px",
              }}
            >
              Cart
            </span>
            {isActive("/cart") && (
              <span
                className="position-absolute bottom-0 rounded-pill"
                style={{
                  width: "16px",
                  height: "2.5px",
                  backgroundColor: "#c49b5b",
                  marginBottom: "-4px",
                }}
              />
            )}
          </Link>

          {/* WhatsApp Quick Order */}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none d-flex flex-column align-items-center py-1 px-2"
            style={{ color: "#25D366" }}
          >
            <i
              className="fa-brands fa-whatsapp"
              style={{
                fontSize: "20px",
                color: "#25D366",
              }}
            ></i>
            <span
              style={{
                fontSize: "10px",
                fontWeight: "600",
                color: "#1E7E34",
                marginTop: "2px",
                letterSpacing: "0.2px",
              }}
            >
              Support
            </span>
          </a>

          {/* My Orders / Account */}
          <Link
            to="/my-orders"
            className="text-decoration-none d-flex flex-column align-items-center py-1 px-2 position-relative"
            style={{
              color: isActive("/my-orders") || isActive("/my-profile") ? "#023319" : "#6c757d",
              transition: "all 0.2s ease",
            }}
          >
            <i
              className="fa-solid fa-user"
              style={{
                fontSize: "18px",
                color: isActive("/my-orders") || isActive("/my-profile") ? "#023319" : "#7A8288",
              }}
            ></i>
            <span
              style={{
                fontSize: "10px",
                fontWeight: isActive("/my-orders") || isActive("/my-profile") ? "700" : "500",
                marginTop: "2px",
                letterSpacing: "0.2px",
              }}
            >
              Account
            </span>
            {(isActive("/my-orders") || isActive("/my-profile")) && (
              <span
                className="position-absolute bottom-0 rounded-pill"
                style={{
                  width: "16px",
                  height: "2.5px",
                  backgroundColor: "#c49b5b",
                  marginBottom: "-4px",
                }}
              />
            )}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BottomNav;
